export enum NavigationMode {
  App = 'app',
  Internal = 'internal',
}
